import React from 'react'
import { useSelector } from 'react-redux'
import { useQueryParam } from '@chilecompra/react-kit'
import { Skeleton, Typography } from '@chilecompra/react-kit/components'
import { Grid, ResumeWrapper } from './QuoteSearchResume.styles'

/*
 * The Search Resume's component
 */
const Resume = () => {
  const {
    loading,
    searchResult: { resultCount }
  } = useSelector(state => state.quoteSearchHeadingFilters)
  const keyword = useQueryParam('keyword')

  return (
    <ResumeWrapper>
      <Grid container>
        <Grid item xs={6}>
          <Typography variant="body2" fontWeight="bold">
            {loading && <Skeleton width="300px" />}
            {!loading && resultCount > 0 && `Existen ${resultCount} resultados para tu búsqueda ${keyword || ''}`}
            {!loading && resultCount === 0 && 'No se encontraron resultados para tu búsqueda'}
          </Typography>
        </Grid>
      </Grid>
    </ResumeWrapper>
  )
}

export default Resume
